import * as ACTION_TYPES from '../types';

let initialState = {
  firmaList: [],
  loading: false
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_FIRMALAR:
        const firmaList = Array.isArray(action.data) ? action.data : [];
        return {...state, firmaList };

      case ACTION_TYPES.DELETE_FIRMA:
        let newList = state.firmaList.filter(firma => firma._id !== action.id);
        return {...state, firmaList: newList };
      
      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_FIRMALAR:
        return {...state, firmaList: []};

      default:
        return state;
    }
  };

